// Single place for contact details and profiles used across the site.
export const EMAIL = 'colin.stebelski@gmail.com';

export const profiles = [
  { label: 'GitHub', url: 'https://github.com/cstebs' },
  { label: 'X', url: 'https://x.com/summitveil' },
];

// GitLab holds only private repos, so it stays off the footer and home page.
export const gitlab = { label: 'GitLab', url: 'https://gitlab.com/cstebelski' };
